module.exports = __webpack_public_path__ + "static/media/default-vuz.701d7169.jpg";